<script>
import moment from "moment";
import Swal from "sweetalert2";
/**
 * Transactions component
 */
export default {
  props: {
    statistics: { type: Object },
  },
  data() {
    return {
      transactionData: [
        {
          agendaid: "#EI1563",
          date: "28 Mar 2020",
          title: "Velho Chico",
          total: "R$ 164",
          paymentstatus: "Pendente"
        },
        {
          agendaid: "#EI1564",
          date: "28 Mar 2020",
          title: "Brsileiro Supera",
          total: "R$ 141",
          paymentstatus: "Pago"
        },
        {
          agendaid: "#EI1565",
          date: "29 Mar 2020",
          title: "Baioano Top",
          total: "R$ 123",
          paymentstatus: "Pago"
        },
        {
          agendaid: "#EI1566",
          date: "30 Mar 2020",
          title: "Tiradentes Brasil",
          total: "R$ 112",
          paymentstatus: "Pago"
        },
        {
          agendaid: "#EI1567",
          date: "31 Mar 2020",
          title: "Pedro Cabral",
          total: "R$ 105",
          paymentstatus: "Pendente"
        },
        {
          agendaid: "#EI1568",
          date: "01 Abr 2020",
          title: "Santos Dumont",
          total: "R$ 160",
          paymentstatus: "Chargeback"
        },
        {
          agendaid: "#EI1569",
          date: "02 Abr 2020",
          title: "Airton Senna",
          total: "R$ 183",
          paymentstatus: "Pago"
        },
        {
          agendaid: "#EI1570",
          date: "03 Abr 2020",
          title: "Jamilson Sampaio",
          total: "R$ 146",
          paymentstatus: "Pago"
        },
        {
          agendaid: "#EI1571",
          date: "03 Abr 2020",
          title: "Edgard Santos",
          total: "R$ 165",
          paymentstatus: "Pendente"
        },
        {
          agendaid: "#EI1572",
          date: "04 Abr 2020",
          title: "Paulo Henrique",
          total: "R$ 172",
          paymentstatus: "Pago"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 25, 50],
      filter: null,
      filterOn: [],
      sortBy: "agendaid",
      sortDesc: false,
      fields: [
        { key: "agendaid", sortable: true, label: "ID" },
        { key: "date", sortable: true, label: "Data" },
        { key: "start_time", sortable: true, label: "Horário" },
        { key: "title", sortable: true, label: "Título" },
        { key: "action" }
      ]
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.transactionData.length;
    }
  },
  mounted() {
    // Primeiros 20 itens ordenador por start date mais recente para mais antigo
    this.transactionData = this.statistics.agendas.sort((a, b) => new Date(b.start) - new Date(a.start)).slice(0, 20).map(agenda => {
      return {
        start: agenda.start,
        end: agenda.end,
        agendaid: "#" + agenda.id,
        date: moment(agenda.start).format('DD/MM/YYYY'),
        title: agenda.title,
        start_time: moment(agenda.start_time, 'HH:mm:ss').format('HH:mm'), // convert "10:00:00" string to "10:00"
      };
    });
    this.totalRows = this.transactionData.length;
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showAgendaSweetAlert(agenda) {
      Swal.fire({
        title: agenda.title,
        text: 'Data: ' + agenda.date + ' - Horário: ' + agenda.start_time,
        icon: 'info'
      });
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <b-dropdown right toggle-class="arrow-none card-drop" class="float-right" variant="white">
        <template v-slot:button-content>
          <i class="mdi mdi-dots-vertical"></i>
        </template>
        <!-- item-->
        <b-dropdown-item>Relatório Vendas</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item>Relatório Exportação</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item>Lucro</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item>Recebíveis</b-dropdown-item>
      </b-dropdown>

      <h4 class="card-title mb-4">Últimos Atendimentos</h4>
      <div class="row mt-4">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Mostrar&nbsp;
              <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
            </label>
          </div>
        </div>
        <!-- Pesquisar -->
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_filter" class="dataTables_filter text-md-right">
            <label class="d-inline-flex align-items-center">
              Pesquisar:
              <b-form-input
                v-model="filter"
                type="search"
                class="form-control form-control-sm ml-2"
              ></b-form-input>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>
      <div class="table-responsive">
        <b-table
          :items="transactionData"
          :fields="fields"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(action)="row">
            <a
              @click="showAgendaSweetAlert(row.item)"
              href="javascript:void(0);"
              class="mr-3 text-primary"
              v-b-tooltip.hover
              data-toggle="tooltip"
              title="Visualizar"
            >
              <i class="mdi mdi-eye font-size-18"></i>
            </a>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- paginacao -->
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>